import { render, staticRenderFns } from "./OwnerIdeaRegisterPage.vue?vue&type=template&id=aac0cc94&"
import script from "./OwnerIdeaRegisterPage.vue?vue&type=script&lang=ts&"
export * from "./OwnerIdeaRegisterPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports